import React, { FunctionComponent } from 'react';
import {
  PercentDoneTray,
  InProgressContainer,
  InProgressCopy,
  PercentDoneMeter,
} from './styled';

interface InProgressBGProps {
  percentDone: number;
}

const InProgressBG: FunctionComponent<InProgressBGProps> = ({
  percentDone,
}) => {
  return (
    <InProgressContainer data-selenium="inProgress">
      <InProgressCopy>Rendering...</InProgressCopy>
      <PercentDoneTray>
        <PercentDoneMeter percentDone={percentDone} />
      </PercentDoneTray>
    </InProgressContainer>
  );
};

export default InProgressBG;
